<template>
  <div
    aria-live="assertive"
    class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end z-50"
  >
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :type="toast.type"
        :title="toast.title"
        :message="toast.message"
        :persistent="toast.persistent"
        :duration="0"
        @close="removeToast(toast.id)"
      />
    </div>
  </div>
</template>

<script setup>
import { toastManager } from '@/composables/useToasts.js'
import Toast from '@/components/ui/Toast.vue'

const { toasts, removeToast } = toastManager
</script>
